import React from 'react';
import { motion } from 'framer-motion';
import { MonitorSmartphone, Code, ShoppingCart, Search, Wrench, LayoutTemplate, Briefcase, RefreshCw } from 'lucide-react';
const services = [{
  icon: <MonitorSmartphone size={32} data-id="element-304" />,
  title: 'Website Design',
  description: 'Stunning, modern designs tailored to your brand identity that captivate visitors instantly.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <Code size={32} data-id="element-305" />,
  title: 'Website Development',
  description: 'Clean, fast, and responsive built with the latest modern web technologies.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <ShoppingCart size={32} data-id="element-306" />,
  title: 'E-Commerce Websites',
  description: 'Secure, high-converting online stores designed to maximize your sales and revenue.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <Search size={32} data-id="element-307" />,
  title: 'SEO Optimization',
  description: 'Built-in best practices to help your site rank higher on Google and attract organic traffic.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <Wrench size={32} data-id="element-308" />,
  title: 'Website Maintenance',
  description: 'Support, updates, and security checks to keep your site running smoothly.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <RefreshCw size={32} data-id="element-309" />,
  title: 'Website Redesigns',
  description: 'Breathe new life into your outdated website with a modern, performance-focused overhaul.',
  color: 'from-blue-600 to-blue-500'
}];
export function Services() {
  return <section id="services" className="py-24 bg-black relative border-y border-white/5" data-id="element-310">
      <div className="container mx-auto px-6 md:px-12" data-id="element-311">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-312">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-313">
            Everything You Need to{' '}
            <span className="text-gradient" data-id="element-314">Succeed Online</span>
          </h2>
          <p className="text-lg text-[#FFFFFF]" data-id="element-315">
            Designed to elevate your brand and drive real business results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-316">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#111118] border border-white/5 rounded-2xl p-8 hover:border-blue-500/30 hover:bg-[#161622] transition-all group" data-id="element-317">
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center text-white mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`} data-id="element-318">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 font-heading" data-id="element-319">
                {service.title}
              </h3>
              <p className="text-sm leading-relaxed text-[#FFFFFF]" data-id="element-320">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}